import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { alturaContainer, anchoMaxLogueado, anchoMaxLogueadoMenuAbierto } from 'utils/constants';
import { RootState } from 'utils/redux/store/store';

const DashboardContainer = ({ children }: any) => {
  const drawerAbierto = useSelector((state: RootState) => state.ui.drawerOpen);

  return (
    <Box
      width={drawerAbierto ? anchoMaxLogueadoMenuAbierto : anchoMaxLogueado}
      mx="auto"
      mt="50px"
      sx={{ backgroundColor: '#f7f7f7' }}
      height="100%"
      minHeight={alturaContainer}
      display="flex"
      flexDirection="column"
    >
      {children}
    </Box>
  );
};

export default DashboardContainer;
